import { render, staticRenderFns } from "./etfList.vue?vue&type=template&id=779ddc35"
import script from "./etfList.vue?vue&type=script&lang=js"
export * from "./etfList.vue?vue&type=script&lang=js"
import style0 from "./etfList.vue?vue&type=style&index=0&id=779ddc35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports